import { combineReducers } from 'redux';

import screenReducer from './reducers/screenReducer';
import roundReducer from './reducers/roundReducer';
import screenPositionReducer from './reducers/screenPositionReducer';

// keeping the reducer collection as a separate exported object enables us
// to do some light test automation on every reducer.
// see ./reducers/__tests__/reducerRejections.test.js
// for more details.
export const reducerCollection = {
  screen: screenReducer,
  round: roundReducer,
  screenPosition: screenPositionReducer,
};

const reducers = combineReducers({ ...reducerCollection });

export default reducers;
